/**
 * Tooltip
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState, useEffect } from 'react';
import clsx from 'clsx';
import Icon from '../Icon';
var buttonRefRef;
/** Main description for this component. */
var Tooltip = function (_a) {
    var label = _a.label, description = _a.description, className = _a.className, _b = _a.position, position = _b === void 0 ? 'center' : _b, props = __rest(_a, ["label", "description", "className", "position"]);
    var buttonRef = useRef(null);
    var _c = useState(false), expanded = _c[0], setExpanded = _c[1];
    var handleClickOutside = function (e) {
        if (buttonRef &&
            buttonRef.current &&
            !buttonRef.current.contains(e.target)) {
            setExpanded(false);
        }
    };
    var handleKeyPress = function (e) {
        if ((e.keyCode || e.which) === 27) {
            setExpanded(false);
        }
    };
    var handleBlur = function () {
        setExpanded(false);
    };
    var handleTouchStart = function () {
        document.addEventListener('touchend', handleTouchEnd, false);
    };
    var handleTouchEnd = function () {
        document.removeEventListener('touchend', handleTouchEnd, false);
        window.setTimeout(function () {
            setExpanded(false);
        }, 100);
    };
    var handleTouchMove = function () {
        document.removeEventListener('touchend', handleTouchEnd, false);
    };
    useEffect(function () {
        if (buttonRef.current) {
            buttonRefRef = buttonRef.current;
            buttonRefRef.addEventListener('blur', handleBlur);
        }
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeyPress);
        document.addEventListener('touchstart', handleTouchStart, false);
        document.addEventListener('touchmove', handleTouchMove, false);
        return function () {
            if (buttonRefRef && buttonRefRef.removeEventListener) {
                buttonRefRef.removeEventListener('blur', handleBlur);
            }
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeyPress);
            document.removeEventListener('blur', handleBlur);
            document.removeEventListener('touchstart', handleTouchStart, false);
            document.removeEventListener('touchmove', handleTouchMove, false);
        };
    });
    var openTooltip = function () {
        if (expanded) {
            setExpanded(false);
        }
        else {
            window.setTimeout(function () {
                setExpanded(true);
            }, 100);
        }
    };
    return (React.createElement("div", { className: clsx(className, 'relative inline-block') },
        React.createElement("button", __assign({ type: "button", className: clsx(expanded ? 'text-teal' : 'text-greyDarker', 'w-6 h-6 hover:text-black'), "aria-label": label, onClick: openTooltip, ref: buttonRef }, props),
            React.createElement(Icon, { icon: "help", "aria-hidden": "true" })),
        React.createElement("div", { className: clsx('tooltip__content', position === 'center' && 'tooltip__content--center', position === 'left' && 'tooltip__content--left', position === 'right' && 'tooltip__content--right', !expanded && 'tooltip__content--hidden'), role: "tooltip", "aria-hidden": expanded ? false : true }, description)));
};
export default Tooltip;
